import buildReactiveChart from '@/libs/buildReactiveChart';

export default buildReactiveChart('bar');
